import React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ClaimPendingList from './ClaimPendingList'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'
import AdxPaginationNew from 'components/reusable/AdxPaginationNew'

const ClaimPendingTab = ({
  pendingData,
  error,
  pagination,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange
}) => {
  const hasPendingClaims = (pendingData || []).length > 0

  return hasPendingClaims ? (
    <Box>
      <Box maxHeight={'calc(100vh - 300px)'} overflow={'auto'} className="scrollbar">
        {(pendingData || []).map((list, index) => (
          <ClaimPendingList key={list.id || index} reportData={list} />
        ))}
      </Box>
      {pagination && (
        <AdxPaginationNew
          count={pagination.total}
          page={page}
          onPageChange={onPageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      )}
    </Box>
  ) : (
    <AdxEmptyStateV2
      title={
        error?.status === 403
          ? 'You are not authorized to access this feature. Please contact your admin for access.'
          : 'No pending claim request'
      }
    />
  )
}

export default ClaimPendingTab
